'use client';

import { useIntl } from 'react-intl';
import usePrintModal from '@alltrails/print/hooks/usePrintModal';
import useClearPrintRequested from './useClearPrintRequested';
import usePrintHost from './usePrintHost';
import usePrintRequested from './usePrintRequested';
import usePrintViewportBounds from './usePrintViewportBounds';

/**
 * Printing a section of explore puts the map itself on paper, the way the legacy print page did.
 * Only the overlays the user turned on come along — there is no route, so nothing else is drawn.
 * Explore shows no print button: the footer's "Print maps" link is the only way in, so the modal
 * opens on arrival and closing it leaves the map as it was.
 */
const ExploreAreaPrintModal = () => {
  const intl = useIntl();
  const bounds = usePrintViewportBounds(true);
  const host = usePrintHost('explore');
  const clearPrintRequested = useClearPrintRequested();
  const { modal } = usePrintModal({
    autoOpen: true,
    bounds,
    host,
    onClose: clearPrintRequested,
    subject: { title: intl.formatMessage({ defaultMessage: 'My map' }) }
  });

  return modal;
};

// Gated out here rather than inside, so explore does not track the viewport or preload the print
// chunk for the vast majority of visitors who never asked to print
const ExploreAreaPrintControl = () => (usePrintRequested() ? <ExploreAreaPrintModal /> : null);

export default ExploreAreaPrintControl;
